import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import WmsSetting from '../../../pages/Setting/WmsSetting';
import SettingList from "../../../pages/Setting/Main/SettingList";
import CreateSetting from "../../../pages/Setting/CreateSetting/CreateSetting";
import EditSetting from "../../../pages/Setting/EditSetting/EditSetting";
import ViewSetting from "../../../pages/Setting/ViewSetting/ViewSetting";

function SettingRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/" element={<SettingList />} />
                <Route path="/add" element={<WmsSetting />} />
                <Route path="/create-setting" element={<CreateSetting />} />
                <Route path="/edit-setting" element={<EditSetting />} />
                <Route path="/view-setting" element={<ViewSetting />} />
            </Route>
        </Routes>
    )
}
export default SettingRoute